'use strict';

export default class ForgotPasswordController {
  user = {
    email: ''
  };
  submitted = false;
  AuthSvc;
  $state;

  constructor(AuthSvc, $state, LoaderSvc) {
    // redirect to main if already logged in
    AuthSvc.isLoggedIn(function(loggedIn) {
      if(loggedIn) {
        $state.go('main');
      }
    });
    this.AuthSvc = AuthSvc;
    this.$state = $state;
    this.LoaderSvc = LoaderSvc;
  }

  submit(form) {
    this.submitted = true;
    if(form.$valid) {
      this.LoaderSvc.start();
      this.AuthSvc.forgotPassword(this.user.email)
        .then(() => {
          this.LoaderSvc.stopSuccess(
            'Check your inbox for an email with a reset password link. '
          + '\n \n(If you do not receive an email, '
          + 'please verify the email is correct and confirm with your club '
          + 'administrator that the email was added to your member record. '
          + 'If it still does not work, please contact your club administrator '
          + 'or Altrusa.)');
          // Logged in, redirect to home
          this.$state.go('main');
        })
        .catch(() => {
          var msg = 'Error: Please contact your club administrator '
          + 'or Altrusa.';
          this.LoaderSvc.stopError(msg);
          this.user.email = '';
        });
    }
  }
}

ForgotPasswordController.$inject = ['AuthSvc', '$state', 'LoaderSvc'];
